import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOfflineMachinesCount } from 'state/ducks/machines/reducer';
import { navigateToSpecificNotification } from 'state/ducks/notifications/operations';
import { localized, localizedInterpolationDynamic } from 'state/i18n';
import { AppState } from 'state/store';
import BiButton from 'view/shared/components/buttons/bi-button/bi-button';
import { NoSubscriptionDialog } from './no-subscription-dialog';

const AddNewNotification: React.FC = () => {
	const dispatch = useDispatch();
	const offlineCount = useSelector((state: AppState) => selectOfflineMachinesCount(state));
	const [showDialog, setShowDialog] = React.useState<boolean>(false);
	const addNewNotification = () => {
		if (offlineCount > 0) {
			setShowDialog(true);
		} else {
			navigateToSpecificNotification(undefined, true)(dispatch);
		}
	};
	const hideDialog = () => {
		setShowDialog(false);
		navigateToSpecificNotification(undefined, true)(dispatch);
	};

	return (
		<>
			<BiButton onClick={addNewNotification} colorTheme="org-primary" containerTheme="normal-button-corners">
				<span className="flex-wrap flex-center-row">
					<span className="white-space-nowrap text-bold">{localized('AddNewNotification')}</span>
				</span>
			</BiButton>
			<NoSubscriptionDialog
				onOk={hideDialog}
				onHide={hideDialog}
				visible={showDialog}
				title={localizedInterpolationDynamic('XMachinesWithoutSubscription', {
					count: offlineCount,
				})}
			/>
		</>
	);
};

export default AddNewNotification;
